import Image from 'app/Components/Shared/Image/image';
import React ,{useEffect} from 'react'
import Config from '../../../../../Config';
import { gaScreenIlPopupDetails } from '../../../AbroadTicketBlock/gaReports';

function PackageDetailsPopup({packageData}) {

  useEffect(() => {
    gaScreenIlPopupDetails();
  }, []);

    return (
      <div className='popUp-details-container'>
        <Image src={Config.epiBaseUrl + packageData.icon} />
        <div className='header'>
            <label className='lg-text'>{packageData.packageName}</label>
            <label className='sm-text'>{packageData.title}</label>
        </div>

        <div className='description'>{packageData.description}</div>
        <div className='includedInPackage'>{
          packageData.includedInPackage?.length>0 &&
           <>
            <span>מה כלול בחבילה?</span>
            <ul>
              {packageData.includedInPackage.map((element,index)=>{return(<li key={index}>{element}</li>)})}
            </ul>
          </>
        }
        </div>
      </div>
    )
  }

export default PackageDetailsPopup
